export default "/images/divide-square.svg?d2a0fb5730653fd6099ddf7ba11f6b45";